import React from 'react';
import { colors } from '../ui/Tokens';
export default function BadgeNumber({ number, isActive = false, showZero = false }) {
    return ((number || showZero) ? (React.createElement("span", { style: {
            height: '16px',
            width: 'auto',
            borderRadius: '30px',
            backgroundColor: isActive ? colors.white : colors.primary10,
            color: isActive ? colors.primary10 : colors.white,
            padding: '0 8px',
            lineHeight: '16px',
            marginLeft: '8px'
        } }, number)
    // <BadgeCounter
    //     count={number}
    //     backgroundColor={isActive ? colors.white : colors.primary10}
    //     textColor={isActive ? colors.primary10 : colors.white}
    // />
    ) : null);
}
